import type { HTMLAttributes } from "react";
// import { TextTruncate } from "@datagame/ui";
import classNames from "classnames/bind";

import type { TriviaAnswerOption } from "../../../gql/graphql";
import { useTime } from "../../../hooks/useTime";

import styles from "./AnswerOption.module.scss";

const cx = classNames.bind(styles);

export interface AnswerOptionProps extends HTMLAttributes<HTMLButtonElement> {
  option: TriviaAnswerOption;
  handleAnswer: (option: TriviaAnswerOption, time: number) => void;
  showCorrectness: boolean;
  disabled?: boolean;
}

export const AnswerOption = ({ option, showCorrectness, handleAnswer, ...buttonProps }: AnswerOptionProps) => {
  const { getCurrentTime } = useTime();

  const handleClick = () => {
    handleAnswer(option, getCurrentTime());
  };

  return (
    <button
      {...buttonProps}
      className={cx("answerOption", { showCorrectness, correct: option.isCorrect })}
      onClick={handleClick}
    >
      <span>{option.text}</span>
      {/* TODO: whole answer should be displayed. No need for truncate */}
      {/* <TextTruncate className={styles.text} text={option.text} /> */}
    </button>
  );
};
